// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L-kc","content":"styles_content__OQOLs","row":"styles_row__3cJgK","footer":"styles_footer__1DvpG","phraseLength":"styles_phraseLength__2Xnpe"};